/**
 * @memberof system-metadata
 * @enum {string}
 * @property {string } COUNT
 * @property {string} INDEX
 * @property {string} MEAN
 * @property {string} MEDIAN
 * @property {string} RATIO
 */
var StatisticalType;
(function (StatisticalType) {
    StatisticalType["COUNT"] = "count";
    StatisticalType["INDEX"] = "index";
    StatisticalType["MEAN"] = "mean";
    StatisticalType["MEDIAN"] = "median";
    StatisticalType["RATIO"] = "ratio";
})(StatisticalType || (StatisticalType = {}));
StatisticalType[StatisticalType.COUNT] = StatisticalType.COUNT;
StatisticalType[StatisticalType.INDEX] = StatisticalType.INDEX;
StatisticalType[StatisticalType.MEAN] = StatisticalType.MEAN;
StatisticalType[StatisticalType.MEDIAN] = StatisticalType.MEDIAN;
StatisticalType[StatisticalType.RATIO] = StatisticalType.RATIO;
export default StatisticalType;
